export const trimAndHashString = (input: string): string => {
  return input.trim().toLocaleLowerCase();
};
